import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Cookie from 'js-cookie'
import axios from "axios"
import request from "./request/request.js"

Vue.prototype.$axios = request
Vue.prototype.$axios1 = axios
Vue.prototype.$Cookie = Cookie
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
